// extracted by mini-css-extract-plugin
export default {"wrapper":"dashboard-panel_wrapper__NLOuH","wrapperContent":"dashboard-panel_wrapperContent__le3l5","aside":"dashboard-panel_aside__LpLGs","main":"dashboard-panel_main__U-VXe"};